import React from 'react';
import { QueryClientProvider, QueryClient } from 'react-query';
import { ResumeSearch } from 'react-scale/components/GrowthCenter/ResumeSearch/ResumeSearch';

const ResumeSearchPage = () => {
  const queryClient = new QueryClient({
    defaultOptions: {
      queries: {
        refetchOnWindowFocus: false,
      },
    },
  });

  return (
    <QueryClientProvider client={queryClient}>
      <ResumeSearch />
    </QueryClientProvider>
  );
};

export default ResumeSearchPage;
